
import { Component, Vue } from "vue-property-decorator";
import draggable from "vuedraggable";
@Component({
  components: { draggable }
})
export default class Template extends Vue {
  arr1: any = [
    { id: 21, name: "技师1", isBusy: false },
    { id: 22, name: "技师2", isBusy: false },
    { id: 23, name: "技师3", isBusy: false },
    { id: 24, name: "技师4", isBusy: false },
    { id: 25, name: "技师5", isBusy: false }
  ];
  arr2: any = [
    { id: 11, name: "1号工位", content1: [], content2: "" },
    { id: 12, name: "2号工位", content1: [], content2: "" },
    { id: 13, name: "3号工位", content1: [], content2: "" },
    { id: 14, name: "4号工位", content1: [], content2: "" },
    { id: 15, name: "5号工位", content1: [], content2: "" }
  ];
  arr3: any = [
    { id: 31, name: "洗车1" },
    { id: 32, name: "维保1" },
    { id: 33, name: "洗车2" },
    { id: 34, name: "维保2" },
    { id: 35, name: "洗车3" }
  ];
  moveId: any = -1;
  end1(e) {
    console.log(e);

    const that = this;
    const items = this.arr2.filter(function (m) {
      return m.id == that.moveId;
    });
    console.log(items);
    items[0].content1.push(this.arr1[e.newDraggableIndex].name);
    this.arr1[e.newDraggableIndex].isBusy = true;
    this.moveId = -1;
  }
  end3(e) {
    console.log(e);

    const that = this;
    const items = this.arr2.filter(function (m) {
      return m.id == that.moveId;
    });
    console.log(items);
    items[0].content2 = this.arr3[e.newDraggableIndex].name;
    this.arr3.splice(e.newDraggableIndex, 1);
  }
  //右边往左边拖动时的事件
  end2(e) {
    const that = this;
    const items = this.arr1.filter(function (m) {
      return m.id == that.moveId;
    });
    //如果左边
    if (items.length < 2) return;
    this.arr1.splice(e.newDraggableIndex, 1);
  }
  //move回调方法
  onMove(e) {
    this.moveId = e.relatedContext.element.id;
    console.log(e.relatedContext.element.id);
    return false;
  }
}
